import React from 'react';
import PropTypes from 'prop-types';
import { useLocale } from '@adsk/alloy-react-helpers';
import { LinkButton } from '@adsk/alloy-react-button';
import {
  errorSectionStyle,
  errorTitleStyle,
  tryAgainLinkStyle,
} from './styles';

const LoadSubscriptionError = ({ onTryAgainClick }) => {
  const { T } = useLocale(({ locale }) => require(`../../i18n/${locale}.json`));

  return (
    <div
      css={errorSectionStyle}
      data-testid="AccountMemberProfilePanel_loadSubcriptionErrorSection"
    >
      <div css={errorTitleStyle}>
        {T.translate('MEMBER_SUBSCRIPTION_LOADING_ERROR_TITLE')}
      </div>
      <LinkButton
        data-testid="AccountMemberProfilePanel_loadSubcriptionError_tryAgainButton"
        onClick={onTryAgainClick}
        style={tryAgainLinkStyle}
      >
        {T.translate('MEMBER_SUBSCRIPTION_LOADING_ERROR_TRY_AGAIN_TEXT')}
      </LinkButton>
    </div>
  );
};

LoadSubscriptionError.propTypes = {
  onTryAgainClick: PropTypes.func.isRequired,
};

export default LoadSubscriptionError;
